import { Controller } from "@hotwired/stimulus"

// Fetches a short-lived (5-minute) signed mobileconfig download URL from the
// server and copies it to the clipboard.
//
// Usage:
//   <button data-controller="mobileconfig-link"
//           data-mobileconfig-link-url-value="/radius_users/alice/mobileconfig_token"
//           data-action="click->mobileconfig-link#copy">
//     Copy link
//   </button>
export default class extends Controller {
  static values = { url: String }

  async copy(event) {
    event.preventDefault()

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/plain"
      }
    })

    if (!response.ok) {
      const message = await response.text()
      alert(message || "Could not generate link.")
      return
    }

    const url = await response.text()

    try {
      await navigator.clipboard.writeText(url)
    } catch {
      // Clipboard API unavailable (non-HTTPS context, permissions denied, etc.)
      // Fall back to prompting the user to copy manually.
      window.prompt("Copy this link:", url)
      return
    }

    // Brief visual feedback on the button
    const original = this.element.innerHTML
    this.element.innerHTML = this.#checkIcon()
    this.element.disabled = true
    setTimeout(() => {
      this.element.innerHTML = original
      this.element.disabled = false
    }, 2000)
  }

  #checkIcon() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-4">
      <path fill-rule="evenodd" d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z" clip-rule="evenodd" />
    </svg>`
  }
}
